export let itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: {id: 0, sku_code: '', article_name: '', unit_name: '', profile_photo: ''},
    set_as_main_item: false,
    item_edit: 0
}

export let dataProps = {
    id: 0,
    catalog_number: 0,
    store_id: null,
    catalog_title: '',
    display_type: 1, //public, private
    customer_id: null, 
    customer_detail: {customer_name: '', profile_photo: ''},
    description: '', 
    image: '',
    internal_notes: '',

    item_list: [],
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreCatalog/properties.js